<div class="delivery-modal modal-app-availability">
  <h5 class="label-text">Update Available</h5>
  <h6 class="label-text">A new version of app is available. Please update</h6>

  <div class="modal-buttons-wrapper">
    <ion-button expand="block"
      (click)="onUpdateBtnClick()"
      class="button apply">
      Update
    </ion-button>
  </div>
</div>
